/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import styled, { css } from "styled-components";

import theme from './PolarisLoginBaseForm.theme';

export const textMedium = css`
  font-size: 0.875rem;
  letter-spacing: 0.01rem;
  line-height: 1.5rem;
`;

export const textSmall = css`
  font-size: 0.75rem;
  letter-spacing: 0.0088rem;
  line-height: 1.0625rem;
`;

export const PolarisLoginBase = styled.div`

.bx--label {
    color: ${props => theme(props).colorPrimary};
    font-weight: 400;
    ${textMedium};
    line-height: 1rem;
    margin-bottom: 1rem;
  }

  .bx--form-requirement {
    background-color: #fff;
  }

  .bx--text-input {
    ${textMedium};
    color: ${props => theme(props).colorPrimary};
    background-color: #fff;
    border-bottom-color: #DBDBDB;

    &::placeholder {
      color: ${props => theme(props).colorPlaceholder};
      ${textSmall};
    }
  }

  .bx--fieldset {
    margin-bottom: 1rem;
  }

  .bx--text-input--password__visibility__toggle {
    top: 0;
  }
  
  .bx--btn.bx--text-input--password__visibility__toggle.bx--tooltip__trigger {
    right: 0.313rem;
  }
  
  .bx--form--fluid .bx--text-input__field-wrapper[data-invalid]:not(:focus) {
    height: 6.5rem;
  }

  .bx--btn.bx--text-input--password__visibility__toggle.bx--tooltip__trigger:focus {
    outline: unset;
  }

  .bx--text-input__invalid-icon {
    right: 1rem;
  }

  .bx--inline-notification--error {
    background-color: #F4F4F4;
    color: ${props => theme(props).colorPrimary};
    font-size: 0.875rem;
  }

  .mandatory-sign-class {
    color: ${props => theme(props).colorStar};
  }

  .under-input-text {
    text-align: right;
    padding-right: 1rem;
    ${textMedium};
  }

  .login-button {
    border-radius: 0.25rem;
    padding: 0.85rem 2.3rem;
    text-align: center;
  }

  .login-button:hover {
    background-color: #71509b;
  }

  .login-button:focus {
    border-color: #71509b;
    box-shadow: none;
  }
  
`

export const ErrorWrapper = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
`